import { useState } from 'react';
import { Link } from 'react-router-dom';
import { beans } from '../data/beans';
import { cities } from '../data/cafes';
import ScoreBar from '../components/ScoreBar';
import Badge from '../components/Badge';

const stats = [
  { num: '80+',   label: 'Quality Score' },
  { num: '11',    label: 'Cafés in India' },
  { num: '1,500', label: 'Cranberry Coffees Daily' },
  { num: '2017',  label: 'Founded in Hyderabad' },
];

const marqueeItems = [
  'Freshly Roasted In-House',
  'Ethically Sourced Estates',
  'Inventor of Cranberry Coffee™',
  'Modern Indian Minimalism',
  'Free Shipping Across India',
  'First Indian Café in Europe',
];

const press = ['GQ India', 'The Hindu', 'YourStory', 'New Indian Express', 'Architectural Digest'];

const featured = beans.slice(0, 3);

export default function Home() {
  const [toast, setToast] = useState(null);
  const [leaving, setLeaving] = useState(false);
  const [cart, setCart] = useState([]);

  function handleAdd(bean) {
    setCart(p => [...p, bean.id]);
    setLeaving(false);
    setToast(bean);
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(() => {
      setLeaving(true);
      setTimeout(() => setToast(null), 300);
    }, 2800);
  }

  return (
    <div className="bg-cream page-enter">

      {/* ── TOAST ── */}
      {toast && (
        <div className={`fixed bottom-8 left-1/2 z-50 ${leaving ? 'toast-out' : 'toast-in'}`}
          style={{ transform: 'translateX(-50%)' }}>
          <div className="bg-maroon text-light px-6 py-4 flex items-center gap-4 shadow-2xl min-w-[300px]">
            <img src={toast.img} alt="" className="w-10 h-10 object-cover flex-shrink-0 opacity-90" onError={e=>e.target.style.display='none'} />
            <div className="flex-1">
              <div className="text-[10px] font-medium text-sand/60 uppercase tracking-widest mb-0.5">Added to cart</div>
              <div className="text-sm text-light/90 truncate">{toast.name}</div>
            </div>
            <div className="text-xs text-sand/40 flex-shrink-0 pl-3 border-l border-sand/15">{cart.length}</div>
          </div>
        </div>
      )}

      {/* ── HERO ── */}
      <section className="grid grid-cols-1 md:grid-cols-2" style={{ minHeight: '80vh' }}>

        {/* Left */}
        <div className="flex flex-col justify-center px-8 md:px-16 py-20">
          <p className="fade-up text-[10px] font-medium tracking-[0.25em] uppercase text-wine/60 mb-6">
            Modern Indian Speciality Coffee
          </p>
          <h1 
            className="fade-up-4 font-serif font-black text-maroon leading-[0.95] mb-8" 
            style={{ fontSize: 'clamp(3.2rem, 6.5vw, 8rem)' }}
          >
            India's Finest,<br />
            <span 
              className="block font-normal" 
              style={{ fontSize: 'clamp(3rem, 5vw, 7.5rem)' }}
            >
              Cup by Cup
            </span>
          </h1>
          <p className="fade-up-2 text-base font-light leading-[1.8] text-maroon/55 max-w-sm mb-10">
            80+ scored beans, roasted in-house, served across 11 cafés
            — and shipped anywhere in India.
          </p>
          <div className="fade-up-3 flex gap-4 flex-wrap">
            <Link to="/shop"
              className="bg-maroon text-light text-xs font-medium tracking-[0.15em] uppercase px-8 py-4 border border-maroon hover:bg-transparent hover:text-maroon transition-colors duration-300">            Shop the Collection
            </Link>
            <Link to="/cafes"
              className="border border-maroon/100 text-maroon text-xs font-medium tracking-[0.15em] uppercase px-8 py-4 hover:bg-maroon/100 hover:text-white transition-colors duration-300">
              Find a Café
            </Link>
          </div>
              <p className="group relative cursor-pointer fade-up text-[10px] font-medium tracking-[0.25em] mt-10 uppercase text-maroon mb-6 w-fit">
        Scroll to Explore
        <span className="absolute -bottom-1 left-0 h-[1px] bg-maroon w-0 transition-all duration-300 ease-out group-hover:w-full"></span>
      </p>
        </div>      

        {/* Right — hero image */}
        <div className="relative overflow-hidden bg-wine" style={{ minHeight: '480px' }}>
          <img
            src="https://roasterycoffee.co.in/wp-content/uploads/2026/02/Frame-27-scaled.png"
            alt="Roastery Coffee House"
            className="img-reveal absolute inset-0 w-full h-full object-cover"
            onError={e => e.target.style.display='none'}
          />
          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute bottom-8 left-8 fade-up-4">
            <span className="bg-cream text-maroon text-[9px] font-medium tracking-[0.15em] uppercase px-3 py-2">
              First Indian Café in Europe — Helsinki, 2024
            </span>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <div className="grid grid-cols-2 md:grid-cols-4 bg-maroon">
        {stats.map((s, i) => (
          <div key={i} className="px-8 py-8 border-r border-sand/10 last:border-r-0">
            <div className="font-serif text-3xl font-light text-light mb-1">{s.num}</div>
            <div className="text-[10px] tracking-[0.12em] uppercase text-sand/40">{s.label}</div>
          </div>
        ))}
      </div>

      {/* ── MARQUEE ── */}
      <div className="bg-wine py-4 overflow-hidden">
        <div className="flex gap-16 animate-marquee whitespace-nowrap w-max">
          {[...marqueeItems, ...marqueeItems].map((item, i) => (
            <span key={i} className="font-serif text-sm font-light text-sand/60 italic tracking-wide flex-shrink-0">
              {item}
              <span className="text-sand/25 mx-4">—</span>
            </span>
          ))}
        </div>
      </div>

      {/* ── FEATURED BEANS ── */}
      <section className="px-8 md:px-16 py-24">
        <div className="flex items-end justify-between mb-14">
          <div>
            <p className="text-[10px] tracking-[0.2em] uppercase text-wine/50 mb-3">Home Brewing</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-maroon leading-tight">
              The Collection
            </h2>
          </div>
          <Link to="/shop" className="text-xs tracking-widest uppercase text-maroon/50 hover:text-maroon transition-colors link-underline hidden md:block">
            View all beans →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-sand/20">
          {featured.map(bean => (
            <div key={bean.id}
              className={`hover-lift group flex flex-col ${bean.featured ? 'bg-maroon' : 'bg-offwhite'}`}>
              <div className="overflow-hidden gap-[20px]" style={{ height: '430px'}}>
                <img src={bean.img} alt={bean.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-103"
                  style={{ transform: 'scale(1.01)' }}
                  onError={e => e.target.style.display='none'} />
              </div>
              <div className="flex flex-col flex-1 p-8">
                <div className="flex items-center justify-between mb-4">
                  <Badge type={bean.badge} label={bean.badgeLabel} />
                  <span className={`text-[10px] tracking-widest uppercase ${bean.featured ? 'text-sand/40' : 'text-maroon/35'}`}>
                    {bean.origin}
                  </span>
                </div>
                <div className={`font-serif text-xl font-light leading-snug mb-2 ${bean.featured ? 'text-light' : 'text-maroon'}`}>
                  {bean.name}
                </div>
                <div className={`text-xs mb-5 ${bean.featured ? 'text-sand/45' : 'text-maroon/45'}`}>{bean.process}</div>
                <div className="flex gap-1.5 flex-wrap mb-5">
                  {bean.notes.map(n => (
                    <span key={n} className={`text-[10px] px-2.5 py-1 rounded-full ${bean.featured ? 'bg-sand/10 text-sand/60' : 'bg-maroon/6 text-maroon/55'}`}>{n}</span>
                  ))}
                </div>
                <ScoreBar score={bean.score} dark={bean.featured} />
                <div className="flex items-center justify-between mt-6 pt-5 border-t border-current/10">
                  <div className={`font-serif text-xl font-light ${bean.featured ? 'text-light' : 'text-maroon'}`}>
                    {bean.priceRange.split('–')[0].trim()}
                  </div>
                  <button onClick={() => handleAdd(bean)}
                    className={`text-[10px] font-medium tracking-[0.12em] uppercase px-5 py-2.5 transition-all duration-300 active:scale-95 ${
                      bean.featured
                        ? 'bg-sand text-maroon hover:bg-light'
                        : 'bg-maroon text-light hover:bg-wine'
                    }`}>
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CAFÉS ── */}
      <section className="px-8 md:px-16 py-16 bg-maroon">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="text-[10px] tracking-[0.2em] uppercase text-sand/35 mb-3">India & Beyond</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-light leading-tight">Our Cafés</h2>
          </div>
          <Link to="/cafes" className="text-xs tracking-widest uppercase text-sand/40 hover:text-light transition-colors link-underline hidden md:block">
            All locations →
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-sand/10">
          {cities.map(city => (
            <Link key={city.id} to="/cafes"
              className="relative overflow-hidden group block bg-wine"
              style={{ height: '280px' }}>
              <img src={city.img} alt={city.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-60"
                onError={e => e.target.style.display='none'} />
              <div className="absolute inset-0 group-hover:bg-maroon/0 transition-colors duration-400" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="font-serif text-lg font-light text-light">{city.name}</div>
                <div className="text-[10px] tracking-widest uppercase text-sand/50 mt-1">
                  {city.cafes.length} café{city.cafes.length > 1 ? 's' : ''}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* ── PRESS ── */}
      <section className="px-8 md:px-16 py-16 bg-cream">
        <p className="text-[10px] tracking-[0.25em] uppercase text-maroon text-center mb-10">As seen in</p>
        <div className="flex flex-wrap gap-10 items-center justify-center">
          {press.map(p => (
            <span key={p} className="font-serif text-base font-light text-maroon tracking-wide">{p}</span>
          ))}
        </div>
      </section>

    </div>
  );
}
